import * as rmsApiProxy from './rmsApiProxy';

const logger = require('../logger/logger.js');

const waitTimeForReAttemptInMs = 500; //Milliseconds

const defaultRetryCount = 3;

export const defaultTimeoutInSeconds = [5, 10, 30];
export const longOperationsTimeoutInSeconds = [20, 40, 60];

var stateManager = require('../state/stateManager');
var runningLateAction = require("../state/actions/views/runningLate/runningLateAction")

export function getOrgContextToUrl()
{
    return rmsApiProxy.getOrgContextToUrl();
} 

export function getFranchisorOrgContextUrl()
{
    return rmsApiProxy.getFranchisorOrgContextUrl();
}

export function getFranchiseeOrgContextUrl()
{
    return rmsApiProxy.getFranchiseeOrgContextUrl();
}

export async function get(resourceUrls, retryCount, onRetryCallBack, allTimeoutSeconds)
{
    if (retryCount == null) retryCount = defaultRetryCount;
    if (allTimeoutSeconds == null || allTimeoutSeconds.length <= 0) allTimeoutSeconds = defaultTimeoutInSeconds;

    stateManager.getStore().dispatch(runningLateAction.createAction(false));
    return _get(resourceUrls, retryCount, onRetryCallBack, 1, allTimeoutSeconds);
}


async function _get(resourceUrls, retryCount, onRertyCallBack, currentAttempt, allTimeoutSeconds)
{
    let timeoutInSeconds = getCurrentTimeoutInSeconds(currentAttempt, allTimeoutSeconds);
    
    try
    {
        const response = await rmsApiProxy.get(resourceUrls, timeoutInSeconds);
        stateManager.getStore().dispatch(runningLateAction.createAction(false));
        return Promise.resolve(response);
    }
    catch(error)
    {
        let isTimeoutError = error.name === 'AbortError' || error.toString().startsWith("Timeout Error");

        if (!isTimeoutError || currentAttempt >= retryCount)
        {
            if (isTimeoutError)
                error = `Timeout Error: Please check your internet connection and try again.`;
            else
                error = error.toString();

            stateManager.getStore().dispatch(runningLateAction.createAction(false));
            return Promise.reject(error);
        }

        if (onRertyCallBack != null)
            onRertyCallBack();

        stateManager.getStore().dispatch(runningLateAction.createAction(true));

        logger.warn(`Timeout error occurred, trying one more time for ${resourceUrls}`);
        await sleep(waitTimeForReAttemptInMs);
        return _get(resourceUrls, retryCount, onRertyCallBack, currentAttempt+1, allTimeoutSeconds);
    }
}

export async function post(resourceUrl, body, retryCount, onRertyCallBack, allTimeoutSeconds)
{
    if (retryCount == null) retryCount = defaultRetryCount;
    if (allTimeoutSeconds == null || allTimeoutSeconds.length <= 0) allTimeoutSeconds = defaultTimeoutInSeconds;

    stateManager.getStore().dispatch(runningLateAction.createAction(false));
    return _post(resourceUrl, body, retryCount, onRertyCallBack, 1, allTimeoutSeconds);
}


async function _post(resourceUrl, body, retryCount, onRertyCallBack, currentAttempt, allTimeoutSeconds)
{
    let timeoutInSeconds = getCurrentTimeoutInSeconds(currentAttempt, allTimeoutSeconds);
    
    try
    {
        const response = await rmsApiProxy.post(resourceUrl, body, timeoutInSeconds);
        stateManager.getStore().dispatch(runningLateAction.createAction(false));
        return Promise.resolve(response);
    }
    catch(error)
    {
        let isTimeoutError = error.name === 'AbortError' || error.toString().startsWith("Timeout Error");

        if (!isTimeoutError || currentAttempt >= retryCount)
        {
            stateManager.getStore().dispatch(runningLateAction.createAction(false));
            return Promise.reject(error);
        }

        if (onRertyCallBack != null)
            onRertyCallBack();

        stateManager.getStore().dispatch(runningLateAction.createAction(true));

        logger.warn(`Timeout error occurred, trying one more time for ${resourceUrl}`);
        await sleep(waitTimeForReAttemptInMs);
        return _post(resourceUrl, body, retryCount, onRertyCallBack, currentAttempt+1, allTimeoutSeconds);
    }
}

export async function put(resourceUrl, body, retryCount, onRertyCallBack, allTimeoutSeconds)
{
    if (retryCount == null) retryCount = defaultRetryCount;
    if (allTimeoutSeconds == null || allTimeoutSeconds.length <= 0) allTimeoutSeconds = defaultTimeoutInSeconds;

    stateManager.getStore().dispatch(runningLateAction.createAction(false));
    return _put(resourceUrl, body, retryCount, onRertyCallBack, 1, allTimeoutSeconds);
}


async function _put(resourceUrl, body, retryCount, onRertyCallBack, currentAttempt, allTimeoutSeconds)
{
    let timeoutInSeconds = getCurrentTimeoutInSeconds(currentAttempt, allTimeoutSeconds);
    
    try
    {
        const response = await rmsApiProxy.put(resourceUrl, body, timeoutInSeconds);
        stateManager.getStore().dispatch(runningLateAction.createAction(false));
        return Promise.resolve(response);
    }
    catch(error)
    {
        let isTimeoutError = error.name === 'AbortError' || error.toString().startsWith("Timeout Error");

        if (!isTimeoutError || currentAttempt >= retryCount)
        {
            stateManager.getStore().dispatch(runningLateAction.createAction(false));
            return Promise.reject(error);
        }

        if (onRertyCallBack != null)
            onRertyCallBack();

        stateManager.getStore().dispatch(runningLateAction.createAction(true));

        logger.warn(`Timeout error occurred, trying one more time for ${resourceUrl}`);
        await sleep(waitTimeForReAttemptInMs);
        return _put(resourceUrl, body, retryCount, onRertyCallBack, currentAttempt+1, allTimeoutSeconds);
    }
}

export async function deleted(resourceUrl, retryCount, onRertyCallBack, allTimeoutSeconds)
{
    if (retryCount == null) retryCount = defaultRetryCount;
    if (allTimeoutSeconds == null || allTimeoutSeconds.length <= 0) allTimeoutSeconds = defaultTimeoutInSeconds;
    
    stateManager.getStore().dispatch(runningLateAction.createAction(false));
    return _deleted(resourceUrl, retryCount, onRertyCallBack, 1, allTimeoutSeconds);
}


async function _deleted(resourceUrl, retryCount, onRertyCallBack, currentAttempt, allTimeoutSeconds)
{
    let timeoutInSeconds = getCurrentTimeoutInSeconds(currentAttempt, allTimeoutSeconds);
    
    try
    {
        const response = await rmsApiProxy.deleted(resourceUrl, timeoutInSeconds);
        stateManager.getStore().dispatch(runningLateAction.createAction(false));
        return Promise.resolve(response);
    }
    catch(error)
    {
        let isTimeoutError = error.name === 'AbortError' || error.toString().startsWith("Timeout Error");

        if (!isTimeoutError || currentAttempt >= retryCount)
        {
            stateManager.getStore().dispatch(runningLateAction.createAction(false));
            return Promise.reject(error);
        }

        if (onRertyCallBack != null)
            onRertyCallBack();

        stateManager.getStore().dispatch(runningLateAction.createAction(true));

        logger.warn(`Timeout error occurred, trying one more time for ${resourceUrl}`);
        await sleep(waitTimeForReAttemptInMs);
        return _deleted(resourceUrl, retryCount, onRertyCallBack, currentAttempt+1, allTimeoutSeconds);
    }
}


function sleep(ms)
{
    return new Promise(resolve => setTimeout(resolve, ms));
}

function getCurrentTimeoutInSeconds(attemptNumber, timeoutInSeconds)
{
    let index = attemptNumber - 1;
    if (index >= timeoutInSeconds.length)
        index = timeoutInSeconds.length - 1;

    return timeoutInSeconds[index];
}